import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PermissionDirective} from './permission.directive';
import {ClickPermissionDirective} from './click-permission.directive';

@NgModule({
  declarations: [PermissionDirective, ClickPermissionDirective],
  imports: [
    CommonModule,
  ],
  exports: [
    PermissionDirective,
    ClickPermissionDirective
  ]
})
export class PermissionModule {
}
